export default "__VITE_ASSET__BQkyiphU__"